import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGamePartnerCreate = {
  gamePartnerCreate: { data: null, loading: false, error: null },
};

export const gamePartnerCreate = createAsyncThunk('user/gamePartnerCreate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/partner/create`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGamePartnerCreate = {
  [gamePartnerCreate.pending]: (state) => {
    state.gamePartnerCreate.loading = true;
  },
  [gamePartnerCreate.fulfilled]: (state, action) => {
    state.gamePartnerCreate.loading = false;
    state.gamePartnerCreate.data = action.payload;
    state.gamePartnerCreate.error = null;
  },
  [gamePartnerCreate.rejected]: (state, action) => {
    state.gamePartnerCreate.loading = false;
    state.gamePartnerCreate.error = action.payload;
  },
};
